import { ArrowUpRight } from "@phosphor-icons/react";

export default function PostSourceCTA({ sourceUrl, sourceName }) {
  if (!sourceUrl) return null;

  return (
    <div className="mt-14 max-w-[760px] mx-auto px-6 md:px-0" data-testid="post-source">
      <div className="border-t border-white/10 pt-8">
        <p className="overline mb-4">Original Source</p>
        <p className="text-white/70 font-light mb-6 max-w-xl">
          This is an original summary based on the official announcement from {sourceName || "the source"}.
          Read the full article on the official page:
        </p>
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="post-source-cta"
          className="inline-flex items-center gap-3 px-8 py-4 border border-[var(--accent)] text-[var(--accent)] uppercase tracking-[0.22em] text-xs font-medium hover:bg-[var(--accent)] hover:text-white transition-colors duration-300"
        >
          Read the Full Article
          <ArrowUpRight size={14} />
        </a>
      </div>
    </div>
  );
}
